import { Component, Input } from '@angular/core';
import { VendasDetalheModel } from '../../models/vendas-detalhe.model';

@Component({
  selector: 'app-produtos-pedido-table',
  templateUrl: './produtos-pedido-table.component.html',
  styleUrls: ['./produtos-pedido-table.component.scss']
})
export class ProdutosPedidoTableComponent {
  @Input() dets: VendasDetalheModel[] = [];

  getValorUnitario(det: VendasDetalheModel): number {
    const total = this.getTotalItem(det);
    const qtd = det?.qtd ?? 0;

    if (qtd > 0 && total > 0) {
      return total / qtd;
    }

    return det?.produto?.valorVenda ?? det?.venda ?? 0;
  }

  getTotalItem(det: VendasDetalheModel): number {
    const totalItem = det?.totalItem ?? 0;

    if (totalItem > 0) {
      return totalItem;
    }

    const valorUnitario = det?.produto?.valorVenda ?? det?.venda ?? 0;
    const qtd = det?.qtd ?? 0;

    return valorUnitario * qtd;
  }

  getObsInfo(obs: string | null | undefined) {
    if (!obs) {
      return { chips: [] };
    }

    const linhas = obs
      .replace(/\r\n/g, '\n')
      .replace(/\r/g, '\n')
      .replace(/\t/g, ' ')
      .split('\n')
      .map(l => l.trim())
      .filter(l => l.length > 0);

    const grupos = new Map<string, Map<string, string>>();

    const adicionarAoGrupo = (rotulo: string, valor: string): void => {
      const valorNormalizado = this._normalizarNomeOpcional(valor);

      if (!valorNormalizado) {
        return;
      }

      const nomeRotulo = rotulo.trim() || 'Obs';

      if (!grupos.has(nomeRotulo)) {
        grupos.set(nomeRotulo, new Map<string, string>());
      }

      const valores = grupos.get(nomeRotulo)!;
      const chave = valorNormalizado.toUpperCase();

      if (!valores.has(chave)) {
        valores.set(chave, valorNormalizado);
      }
    };

    for (const linha of linhas) {
      const match = linha.match(/^([^:]+):\s*(.*)$/);

      if (!match) {
        linha
          .split(',')
          .map(v => v.trim())
          .filter(v => v.length > 0)
          .forEach(item => adicionarAoGrupo('Obs', item));
        continue;
      }

      const rotulo = match[1].trim();
      const valor = match[2].trim();

      valor
        .split(',')
        .map(v => v.trim())
        .filter(v => v.length > 0)
        .forEach(item => adicionarAoGrupo(rotulo, item));
    }

    const chips = Array.from(grupos.entries()).map(([rotulo, valores]) => (
      `${rotulo}: ${Array.from(valores.values()).join(', ')}`
    ));

    return { chips };
  }

  private _normalizarNomeOpcional(valor: string): string {
    const limpo = valor
      .replace(/\s+/g, ' ')
      .replace(/^[-•]+\s*/, '')
      .trim();

    if (!limpo) {
      return '';
    }

    // Corrige duplicacoes concatenadas vindas do backend: "MaioneseMaionese" -> "Maionese".
    const duplicadoConcatenado = limpo.match(/^(.{2,}?)\1+$/i);

    if (duplicadoConcatenado?.[1]) {
      return duplicadoConcatenado[1].trim();
    }

    return limpo;
  }
}
